"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/wireless-points-bulk-validate`;
    }
    /**
     * Validates wireless points before creation or update. The maximum
   * number of wireless points per request is 10 000.
   *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points-bulk-validate
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async post(validateMultipleWirelessPointsRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), validateMultipleWirelessPointsRequest, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map